import styled from "styled-components";

export const FirstAccessContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  padding: 2rem;
  background: ${({ theme }) => theme.colors.secondaryBackgroundColor};

  input {
    background: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    color: ${({ theme }) => theme.checkoutOnePage.textColor};
  }

  @media (max-width: 500px) {
    padding: 2rem 1rem;
  }

  @media (max-width: 375px) {
    padding: 2rem 0.5rem;
  }
`;

export const FirstAccessContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  max-width: 30.75rem;

  .password {
    margin: 0 0 1rem;
  }

  .confirm-password {
    margin: 1.5rem 0 1rem;
  }
`;

export const WrapperValidations = styled.div`
  width: 100%;

  .validation-message {
    margin: 0 0 0.5rem;
  }

  .validation-message:last-child {
    margin: 0;
  }
`;

export const Title = styled.h1`
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.checkoutOnePage.textColor};

  width: 100%;
  margin: 0 0 1rem;
`;

export const Paragraph = styled.p`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.checkoutOnePage.textColor};

  width: 100%;
  margin: 0 0 2rem;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 2.5rem;
  position: relative;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 3rem;
  margin: 2rem 0 0;

  font-family: Inter;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;

  border: none;
  cursor: pointer;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textMasterColor};

  &:hover {
    transition: ease-in 200ms;
    transform: scale(1.005);
  }
`;

export const Image = styled.img`
  max-width: 16rem;

  margin: 0 0 2.5rem;
`;
